import $ from 'jquery';
import SimpleBar from 'simplebar'; 